import { Capacitor } from '@capacitor/core'

const headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json'
}

export class HttpService {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private async makeRequest(url: string, method: string, data?: any) {
    try {
      const options: RequestInit = {
        method,
        credentials: 'include',
        mode: 'cors',
        headers: { 'X-Platform': Capacitor.isNativePlatform() === true ? 'NativeApp' : 'WebPortal' }
      }

      //If data is FormData we dont want the default allow json headers, etc. this can be used for file upload
      if (data instanceof FormData) {
        options.body = data
      } else {
        options.body = JSON.stringify(data)
        options.headers = headers
      }

      const response = await fetch(url, options)
      return this.handleResponse(response)
    } catch (error) {
      console.error(`${method} request failed:`, error)
      throw error
    }
  }

  async handleResponse(response: Response) {
    if (!response.ok) {
      const errorMessage = await response.text()
      throw new Error(`HTTP Error: ${response.status} - ${errorMessage}`)

      // Or handle 401 and 403 like so:
      // if (response.status === 401 || response.status === 403) {
      //   // Handle 401/403 errors
      // } else {
      //   const errorMessage = await response.text()
      //   throw new Error(`HTTP Error: ${response.status} - ${errorMessage}`)
      // }
    }

    const contentType = response.headers.get('content-type')
    if (contentType && contentType.includes('application/json')) {
      return response.json()
    } else {
      return response
    }
  }

  async get(url: string) {
    return this.makeRequest(url, 'GET')
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async post(url: string, data: any) {
    return this.makeRequest(url, 'POST', data)
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async put(url: string, data?: any) {
    return this.makeRequest(url, 'PUT', data)
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async delete(url: string, data: any) {
    return this.makeRequest(url, 'DELETE', data)
  }
}

export const httpService = new HttpService()
